import React, { useEffect, useMemo, useState } from 'react';
import turfimage from '../Assets/Images/slider-image.jpg';
import { getBookingsList } from '../Utils/API';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Tab, TabList, TabPanel, Tabs } from 'react-tabs';
import { NavLink } from 'react-router-dom';
import usePaginatedData from '../Utils/hooks/usePaginatedData';
import { ArrowLeft, ArrowRight } from 'iconsax-react';

export default function AllBookings() {
    const userDetails = useSelector(state => state.user?.userDetails);
    const initialFilterState = {
        user: userDetails?.id,
        page: 1,
        page_size: 10,
    };
    const [filterObject, setFilterObject] = useState(initialFilterState);

    const {
        filterData: bookingFilterData,
        pageNo,
        pageChangeHandler,
        recordChangeHandler,
        fetchData,
    } = usePaginatedData(1, 10, getBookingsList, filterObject);

    const BookingCard = ({ booking }) => {

        const profileImages = booking?.venue?.profile_image 
        ? JSON.parse(booking?.venue?.profile_image) 
        : [];


        return(
        <NavLink to='/booking_summary' state={booking} className="p-4 bg-white border w-[480px] min-w-[380px] max-h-[400px] border-red-500 rounded-lg shadow-md mx-1 sm:mx-4 overflow-hidden">
            {/* <div className="text-red-600 font-bold text-lg mb-2 text-center">
                Court
            </div> */}
            <div className="bg-red-100 text-red-600 font-semibold py-2 px-3 rounded mb-4">
                {booking?.booking_id}
            </div>
            <div className="flex flex-row gap-4 items-start justify-start mb-4 min-w-[180px]">
                <img
                    src={profileImages[0]?.media_url}
                    alt="Turf"
                    className="w-[150px] h-[100px] rounded object-cover bg-gray-300"
                />
                <div className="flex flex-1 justify-between items-start rounded-md pb-3.5">
                    <div className='pr-2'>
                        <p className="text-gray-800 font-bold text-lg sm:text-left text-start">
                            {booking?.sport_name}
                        </p>
                        <p className="text-gray-600 text-sm text-start sm:text-left">
                            {moment(booking?.create_datetime).format('MMMM DD, YYYY')}
                        </p>
                        <p className="text-gray-600 text-sm sm:text-left text-start">
                            {booking?.time_slot}
                        </p>
                    </div>
                    <div className="mt-1 text-center sm:text-left">
                        <span
                            className={`text-sm font-semibold px-3 py-1 rounded ${booking?.payment_status === 'Paid'
                                    ? 'bg-green-200 text-green-600'
                                    : booking?.payment_status === 'Pending'
                                        ? 'bg-yellow-200 text-yellow-600'
                                        : booking?.payment_status === 'Partially Paid' ? 'bg-violet-100 text-violet-600' : 'bg-red-200 text-red-600'
                                    }`}
                        >
                            {booking?.payment_status}
                        </span>
                    </div>
                </div>
            </div>
            <div className="flex justify-between items-center">
                <p className="text-gray-700 font-medium text-sm">
                    {booking?.venue?.name}
                </p>
                <p className="text-gray-800 font-bold text-lg text-right">
                    ₹ {booking?.amount_paid}
                </p>
            </div>
        </NavLink>)
    };

    return (
        <>
            <h1 className="text-gray-800 font-bold text-2xl ml-4 mt-5">Bookings Details</h1>
            <div className="flex flex-row flex-wrap gap-4 bg-gray-50 pt-3 pb-8">
                {bookingFilterData?.length === 0 ? (
                    <div className="flex flex-row gap-4 items-center justify-center">
                        <p>No Booking Found</p>
                    </div>
                ) : (
                    <>
                        {bookingFilterData?.map((booking, index) => (
                            <BookingCard key={index} booking={booking} />
                        ))}
                    </>
                )}

                {bookingFilterData?.length > 0 && (
                    <div className="flex flex-row justify-end gap-4 mt-3 mx-3 sm:mx-8 w-full">
                        <span
                            onClick={() => {
                                pageChangeHandler(pageNo - 1);
                            }}
                        >
                            <ArrowLeft size="32" className="text-primary" variant="Bold" />
                        </span>
                        <span
                            onClick={() => {
                                pageChangeHandler(pageNo + 1);
                            }}
                        >
                            <ArrowRight size="32" className="text-primary" variant="Bold" />
                        </span>
                        <select
                            className="p-3 py-1 select-width-data-table-wo-pagination title-font-500 fs-2 border-none w-16 text-center"
                            defaultValue={"10"}
                            onChange={(e) => {
                                recordChangeHandler(e.target.value);
                            }}
                        >
                            <option value="8">8</option>
                            <option value="10">10</option>
                            <option value="25">25</option>
                            <option value="50">50</option>
                        </select>
                    </div>
                )}
            </div>
        </>

    );
}
